import React, { useState, useEffect, useCallback } from "react";
import Loadspinner from "../../../common/Loadspinner";
import Main from "../../../common/Main/Main";
import InputForm from "../../../ReusableComponents/InputForm/InputForm";
import SelectForm from "../../../ReusableComponents/SelectForm/SelectForm";
import { APICall } from "../../../helpers/API/APICalls";
import FormLabel from "../../../ReusableComponents/FormLabel/FormLabel";
import ErrorLabel from "../../../ReusableComponents/ErrorLabel/ErrorLabel";
import {
  getUserRoleMasterDataById,
  insertUpdateUserRoleMaster,
  getCommonDropdownData,
} from "../../../helpers/API/APIEndPoints";
import moment from "moment";
import notify from "../../../ReusableComponents/ToastNotification/ToastNotification";
import { useHistory, useParams } from "react-router-dom";
import {
  saveRecordMsg,
  updateRecordMsg,
} from "../../../helpers/Constants/Constants";
import SubmitButton from "../../../ReusableComponents/Buttons/SubmitButton/SubmitButton";
import ResetButton from "../../../ReusableComponents/Buttons/ResetButton/ResetButton";
import CancelButton from "../../../ReusableComponents/Buttons/CancelButton/CancelButton";
import Decrypt2 from "../../../helpers/Cryptography/CryptoJS";
import CommonConstants from "../../../constants/CommonConstants";
import { getFromEncLocalStorage } from "../../../helpers/Utils/Utils";

const UserRoleMasterEdit = (props) => {
  let history = useHistory();
  const { id: userRoleId } = useParams();
  const [emailId, setEmailId] = useState("");
  const [id, setId] = useState(0);
  const [uId, setUId] = useState(1);
  const [isActive, setIsActive] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [userName, setUserName] = useState({});
  const [userNameOptions, setUserNameOptions] = useState([]);
  const [userRole, setUserRole] = useState({});
  const [userRoleOptions, setUserRoleOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editModeDisableButton, setEditModeDisableButton] = useState(true);

  let formErrorObj = {};
  let state_id = 0;

  const [userNames, setUserNames] = useState({});
  const [userRoles, setUserRoles] = useState({});

  const onSubmitValidation = () => {
    setFormErrors({});
    formErrorObj = {};
    if (!userName || Object.keys(userName).length <= 0 || userName === "") {
      formErrorObj["userName_isEmpty"] = "User name can not be empty";
    }
    if (!emailId || emailId.length <= 0) {
      formErrorObj["emailId_isEmpty"] = "Email id can not be empty";
    }
    if (!userRole || Object.keys(userRole).length <= 0 || userRole === "") {
      formErrorObj["userRole_isEmpty"] = "User role can not be empty";
    }


    setFormErrors(formErrorObj);
  };

  const onClickFunction = async (event, action) => {
    setLoading(true);
    if (action === "Submit") {
      await onSubmitValidation();
      let isEmpty = Object.values(formErrorObj).every((f) => {
        f === "" || f === null || f === undefined;
      });
      if (isEmpty === true) {

        let requestParams = {
          Id: id,
          UserId: userName.value,
          RoleId: userRole.value,
          IsActive: isActive,
          CreatedByUserId: getFromEncLocalStorage("userId"),
          CreatedDate: moment(new Date()).format("yyyy-MM-DD HH:mm:ss"),
        };
        console.log(requestParams);

        const res = await APICall(
          insertUpdateUserRoleMaster,
          requestParams,
          "POST"
        );

        if (res.message === "Ok") {
          if (res && res.data !== 0) {
            if (id === 0) {
              notify(0, saveRecordMsg);
            } else if (id > 0) {
              notify(0, updateRecordMsg);
            }
            history.push({ pathname: "/userrole-master" });
          }
        } else {
          notify(1, res.message);
        }
      }
    } else if (action === "Reset") {
      resetFunction();
    } else if (action === "Cancel") {
      history.push({ pathname: "/userrole-master" });
    }
    setLoading(false);
  };

  const getCommonDropdownDataApiCall = async () => {
    setLoading(true);
    let requestParams = {
      dropdownName: "userRole",
    };
    const res = await APICall(getCommonDropdownData, requestParams, "POST");

    if (res && res.data.length > 0) {
      let options = await res.data;
      options = await options.map((ele) => ({
        label: ele.Name,
        value: ele.Id,
      }));

      await setUserRoleOptions(options);

      setLoading(false);
    } else {
      await setUserRoleOptions([]);
      notify(1, res.message);
      setLoading(false);
    }
  };

  const getCommonDropdownUserNameDataApiCall = async () => {
    setLoading(true);
    let requestParams = {
      dropdownName: "userNameProfileAll",
    };
    const res = await APICall(getCommonDropdownData, requestParams, "POST");

    if (res && res.data.length > 0) {
      let options = await res.data;
      options = await options.map((ele) => ({
        label: ele.UserName,
        value: ele.UserId,
      }));

      await setUserNameOptions(options);

      setLoading(false);
    } else {
      await setUserNameOptions([]);
      notify(1, res.message);
      setLoading(false);
    }
  };



  const getUserRoleMappingByIdApiCall = async (id) => {
    setLoading(true);
    let requestParams = {
      id: id,
    };

    const res = await APICall(
      getUserRoleMasterDataById,
      requestParams,
      "POST"
    );

    if (res.message === "Ok" && res.data.length > 0) {
      setId(res.data[0][0].Id);
      setEmailId(res.data[0][0].EmailId);

      await getCommonDropdownUserNameDataApiCall();

      let userNames = {};
      userNames = await res.data[0].map((ele) => ({
        label: ele.UserName,
        value: ele.UserId,
      }));
      setUserNames(userNames[0]);

      let userRoles = {};
      userRoles = await res.data[0].map((ele) => ({
        label: ele.UserRole,
        value: ele.RoleId,
      }));
      setUserRoles(userRoles[0]);

      setIsActive(res.data[0][0].IsActive);

      setLoading(false);
    } else {
      notify(1, res.message);
      history.push({ pathname: "/userrole-master" });
      setLoading(false);
    }
  };


  useEffect(() => {
    if (userNameOptions.length > 0 && Object.keys(userNames).length > 0) {
      let tempOption = userNameOptions.find(
        (ele) => ele.label === userNames.label && ele.value === userNames.value
      );
      setUserName(tempOption);
    }

    if (userRoleOptions.length > 0 && Object.keys(userRoles).length > 0) {
      let tempOption = userRoleOptions.find(
        (ele) => ele.label === userRoles.label && ele.value === userRoles.value
      );
      setUserRole(tempOption);
    }


  }, [
    userNames,
    userNameOptions,
    userRoles,
    userRoleOptions,
  ]);

  const onLoadApiCall = async () => {
    setLoading(true);
    await getCommonDropdownDataApiCall();
    setEditModeDisableButton(false)
    // state_id = userRoleId //history?.location?.state?.id;
    state_id = await Decrypt2(getFromEncLocalStorage("tokennumber")); //history?.location?.state?.id;

    if (state_id != 0 || state_id != "0") {
      await getUserRoleMappingByIdApiCall(state_id);
      setId(state_id);
      setEditMode(true);
    } else {
      resetFunction();
    }
    setLoading(false);
  };

  useEffect(() => {
    onLoadApiCall();
  }, []);

  const selectOnChange = (event, apiFieldName) => {
    if (apiFieldName === "userName") {
      setUserName(event);
      setEmailId(event.EmailId);
    } else if (apiFieldName === "userRole") {
      setUserRole(event);
    }
  };

  const resetFunction = () => {
    setFormErrors({});
    formErrorObj = {};
    setUserRole({});

    if (!editMode) {
      setUserName({});
      setEmailId("");
      setIsActive(true);
    }
  };

  const handleTextEvent = async (event, field) => { };

  const getUserNames = async (e, callback) => {
    if (e.length > 3) {
      let requestParams = {
        dropdownName: "userNameSearchProfile",
        searchText: e,
      };
      const res = await APICall(getCommonDropdownData, requestParams, "POST");
      if (res && res.data.length > 0) {
        let options = await res.data;
        options = await options.map((ele) => ({
          label: ele.UserName,
          value: ele.UserId,
          EmailId: ele.EmailId,
        }));

        await callback(options);
      }
    }
  };
  return (
    <>
      <Main active={"userrole_master"} removeContainer={true}>
        <Loadspinner filename="UserRoleMasterEdit.js" isLoading={loading} isMiddle="false" />
        <div className="eventGalleryEdit">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-md-4">
                <h4 style={{ paddingLeft: "5px" }}>Master</h4>
              </div>
              <div className="clearfix"></div>
              <div
                className="d-flex align-items-center justify-space-between"
                style={{
                  background: "#e61636",
                  padding: "10px 20px 10px 10px",
                  color: "white",
                  width: "100%",
                }}
              >
                <div className="col-lg-8">User Role</div>
              </div>

              <div className="col-lg-12 col-md-12">
                <div className="row mt-3">
                  <div className="col-lg-3 col-sm-3 col-xs-4 ">
                    <div className="form-group">
                      {/* <label className="col-form-label">User Name</label> */}
                      <FormLabel value="User Name" />
                      <sup>*</sup>
                      <SelectForm
                        async
                        isSearchable
                        options={(e, callback) => getUserNames(e, callback)}
                        placeholder="Search User"
                        defaultOptions={editMode ? userNameOptions : []}
                        isDisabled={editMode ? true : false}
                        value={userName}
                        onChange={(event) => selectOnChange(event, "userName")}
                        isMulti={false}
                        noIndicator={false}
                        noSeparator={false}
                      />
                      {/* <p style={{ color: "red" }}>
                        {formErrors["userName_isEmpty"]}
                      </p> */}
                      <ErrorLabel value={formErrors["userName_isEmpty"]} />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-3 col-xs-4 ">
                    <div className="form-group">
                      {/* <label className="col-form-label">Email Id</label> */}
                      <FormLabel value="Email Id" />
                      <sup>*</sup>
                      <InputForm
                        className="form-control form-control-sm"
                        size="lg"
                        placeholder={""}
                        isDisabled={true}
                        textArea={false}
                        value={emailId}
                        onChange={(e) => handleTextEvent(e, "EmailId")}
                        style={{ fontSize: '15px' }}
                      />
                      {/* <p style={{ color: "red" }}>
                        {formErrors["emailId_isEmpty"]}
                      </p> */}
                      <ErrorLabel value={formErrors["emailId_isEmpty"]} />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-3 col-xs-4 ">
                    <div className="form-group">
                      {/* <label className="col-form-label">User Role</label> */}
                      <FormLabel value="User Role" />
                      <sup>*</sup>
                      <SelectForm
                        options={userRoleOptions}
                        placeholder="Select Role"
                        isDisabled={false}
                        value={userRole}
                        onChange={(event) => selectOnChange(event, "userRole")}
                        isMulti={false}
                        noIndicator={false}
                        noSeparator={false}
                      />
                      {/* <p style={{ color: "red" , }}>
                        {formErrors["userRole_isEmpty"]}
                      </p> */}
                      <ErrorLabel value={formErrors["userRole_isEmpty"]} />
                    </div>
                  </div>

                  <div className="col-lg-3 col-sm-3 col-xs-4 ">
                    <div className="form-group">
                      {/* <label className="col-form-label">Active Status</label> */}
                      <FormLabel value="Active Status" />
                      <sup>*</sup>
                      <div className="custom-checkbox">
                        <input
                          disabled={editMode ? false : true}
                          type="checkbox"
                          onChange={(e) => setIsActive(e.target.checked)}
                          name="isActive"
                          className="isActive"
                          checked={isActive}
                          autoComplete={CommonConstants.autoCompleteInput}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-12 col-md-12 mt-3">
                <div className="row">
                  <div className="col-lg-11 col-md-11" style={{ width: "97%" }}>
                    <div className="float-right">
                      <SubmitButton onClick={(e) => onClickFunction(e, "Submit")} />
                      {editModeDisableButton && (
                        <ResetButton onClick={(e) => onClickFunction(e, "Reset")} />
                      )}

                      <CancelButton onClick={(e) => onClickFunction(e, "Cancel")} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Main>
    </>
  );
};

export default UserRoleMasterEdit;
